import { useEffect, useState } from 'react';
import WebHelper from './WebHelper';
import moment from 'moment';
import 'moment/locale/pl';

function Calendar({ workHours, exceptions, reservations, overSeer, startDate, selectedDate, selectedTime, setSelectedDate, setSelectedTime }) {

    const getCell = (hour, day) => {
        const weekDay = day.day();
        const dateStr = day.format('yyyy-MM-DD');
        const isSelected = selectedDate === dateStr && selectedTime === hour;
        const exception = exceptions?.find(x => x.Date === day.format('yyyy-MM-DD'));
        const reservation = reservations?.find(x => x.startTime.split(' ')[0] === day.format('yyyy-MM-DD') && x.startTime.split(' ')[1] === hour + ":00");

        let date = undefined;
        if (exception) {
            const wh = JSON.parse(exception.workHours);
            date = wh.find(x => x === hour);
        }
        else {
            date = workHours[weekDay].find(x => x === hour);
        }

        if (date) {
            return (
                <td className={(isSelected ? "reservation-cell-selected" : "reservation-cell") + (reservation ? " reservation-cell-disabled" : "")} 
                onClick={() => { if (!reservation) { setSelectedDate(dateStr); setSelectedTime(date) } }}>
                    {date ? date : "-"}
                </td>
            )
        }

        return (
            <td>
                {date ? date : "-"}
            </td>
        );
    }

    const getRow = (hour) => {
        let sDate = moment(startDate);
        return (
            <tr>
                {getCell(hour, sDate)}
                {getCell(hour, sDate.add(1, 'days'))}
                {getCell(hour, sDate.add(1, 'days'))}
                {getCell(hour, sDate.add(1, 'days'))}
                {getCell(hour, sDate.add(1, 'days'))}
                {getCell(hour, sDate.add(1, 'days'))}
                {getCell(hour, sDate.add(1, 'days'))}
            </tr>)
    }

    const getRows = () => {
        let allHours = [];

        Object.keys(workHours).forEach((day) => {
            workHours[day].forEach(hour => {
                if (!allHours.includes(hour)) {
                    allHours.push(hour);
                }
            });
        });

        const rows = [];

        allHours.sort();
        allHours.forEach((hour) => {
            rows.push((getRow(hour)));
        });

        return rows;
    }

    let sDate = moment(startDate);

    moment.locale('pl');
    return (
        <div className="App" style={{ display: 'flex', flexGrow: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
            <table>
                <thead>
                    <tr>
                        <th className='reservationHeader'>{sDate.format('dddd (DD-MM)')}</th>
                        <th className='reservationHeader'>{sDate.add(1, 'days').format('dddd (DD-MM)')}</th>
                        <th className='reservationHeader'>{sDate.add(1, 'days').format('dddd (DD-MM)')}</th>
                        <th className='reservationHeader'>{sDate.add(1, 'days').format('dddd (DD-MM)')}</th>
                        <th className='reservationHeader'>{sDate.add(1, 'days').format('dddd (DD-MM)')}</th>
                        <th className='reservationHeader'>{sDate.add(1, 'days').format('dddd (DD-MM)')}</th>
                        <th className='reservationHeader'>{sDate.add(1, 'days').format('dddd (DD-MM)')}</th>
                    </tr>
                </thead>
                <tbody>
                    {getRows()}
                </tbody>
            </table>
        </div>
    );
}

export default Calendar;
